module.exports = __webpack_public_path__ + "img/17.152e8920.png";